import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Resets the window scroll position to the top whenever the route changes,
 * so navigating to a new page always starts at the top instead of keeping
 * the previous page's scroll offset.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}